'use client'

import parse from 'html-react-parser'
import { usePagination } from 'react-instantsearch'

type FilterPaginationProps = {
  gridRef?: React.RefObject<HTMLDivElement>
}

export default function FilterPagination({ gridRef }: FilterPaginationProps) {
  const { pages, refine, currentRefinement } = usePagination({
    padding: 2,
  })

  if (!pages?.length) {
    return null
  }

  const totalPages = pages.length
  const currentPageNumber = currentRefinement + 1

  const hasNextPage = currentPageNumber < totalPages
  const hasPreviousPage = currentPageNumber > 1

  const currentUrl = typeof window !== 'undefined' ? new URL(window.location.href) : null

  const nextUrl = currentUrl ? new URL(currentUrl.href) : null
  const prevUrl = currentUrl ? new URL(currentUrl.href) : null

  if (nextUrl && hasNextPage) {
    nextUrl.searchParams.set('page', (currentPageNumber + 1).toString())
  }

  if (prevUrl && hasPreviousPage) {
    prevUrl.searchParams.set('page', (currentPageNumber - 1).toString())
  }

  return (
    <>
      {/* Add rel="next" and rel="prev" links for SEO */}
      {hasNextPage && nextUrl ? parse(`<link rel="next" href="${nextUrl.href}" />`) : null}
      {hasPreviousPage && prevUrl ? parse(`<link rel="prev" href="${prevUrl.href}" />`) : null}

      {/* Pagination controls */}
      <ul role="navigation" className="flex items-center gap-x-l text-17 s:text-14">
        {pages?.length > 1
          ? pages.map((page) => (
              <li key={page}>
                {currentRefinement !== page ? (
                  <a
                    href="#"
                    onClick={(event) => {
                      event.preventDefault()

                      refine(page)

                      if (gridRef?.current && gridRef.current !== null) {
                        gridRef.current.scrollIntoView({
                          behavior: 'smooth',
                          block: 'start',
                          inline: 'nearest',
                        })
                      }
                    }}>
                    {page + 1}
                  </a>
                ) : (
                  <strong>{page + 1}</strong>
                )}
              </li>
            ))
          : null}
      </ul>
    </>
  )
}
